import { Box } from "@material-ui/core";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import Login from "./Login";

export const AuthenticationRouter = () => {
  let match = useRouteMatch();

  return (
    <Box
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="primary.main"
    >
      <Box bgcolor="secondary.main" borderRadius="8px">
        <Switch>
          <Route path={`${match.url}/login`}>
            <Login />
          </Route>
        </Switch>
      </Box>
    </Box>
  );
};
